import { useEffect } from "react";
import { useAnimate, stagger } from "framer-motion";

export function Example() {
    const dots = Array.from({ length: 30 }, (_, i) => i + 1);

    const [scopeMotionEasing, animateMotionEasing] = useAnimate();
    const [scopeBezier, animateBezier] = useAnimate();
    const [scopeFunction, animateFunction] = useAnimate();

    useEffect(() => {
        animateMotionEasing(
            "div",
            { scale: [0.5, 1.3, 1] },
            { delay: stagger(0.1, { ease: "easeOut" }) }
        );
        animateBezier(
            "div",
            { scale: [0.5, 1.3, 1] },
            { delay: stagger(0.1, { ease: [0.65, 0, 0.35, 1] }) }
        );
        animateFunction(
            "div",
            { scale: [0.5, 1.3, 1] },
            { delay: stagger(0.1, { ease: easeInCubic }) }
        );
    }, []);

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="flexForText" style={{ marginTop: -20 }}>
                <h1 className="title">Framer Motion easing</h1>
                <p className="codeExample">{`{ ease: "easeOut" }`}</p>
            </div>
            <div className="row" ref={scopeMotionEasing}>
                {dots.map((dot, i) => {
                    return (
                        <div className="dot" key={i}>
                            {dot}
                        </div>
                    );
                })}
            </div>

            <div className="flexForText">
                <h1 className="title">Bézier curve</h1>
                <p className="codeExample">{`{ ease: [0.65, 0, 0.35, 1] }`}</p>
            </div>
            <div className="row" ref={scopeBezier}>
                {dots.map((dot, i) => {
                    return (
                        <div
                            className="dot"
                            style={{ backgroundColor: "RoyalBlue" }}
                            key={i}
                        >
                            {dot}
                        </div>
                    );
                })}
            </div>

            <div className="flexForText">
                <h1 className="title">Easing function</h1>
                <p className="codeExample">{`{ ease: easeInCubic  }`}</p>
            </div>
            <div className="row" ref={scopeFunction}>
                {dots.map((dot, i) => {
                    return (
                        <div
                            className="dot"
                            style={{ backgroundColor: "OrangeRed" }}
                            key={i}
                        >
                            {dot}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

// https://easings.net/#easeInCubic
function easeInCubic(x) {
    return x * x * x;
}
